import { useQuery } from '@tanstack/react-query';
import { CancellationReasonsService } from '../services';
import { IGetCancellationReasonsPayload } from '../types';

interface IUseGetCancellationReasonsOptions {
  enabled?: boolean;
}

export const useGetCancellationReasons = (
  payload?: IGetCancellationReasonsPayload,
  options: IUseGetCancellationReasonsOptions = {},
) => {
  const { data, isFetching, isLoading, isError, error, refetch } = useQuery({
    initialData: {
      data: [],
    },
    queryKey: ['GET_CANCELLATION_REASONS', { payload }],
    queryFn: async () => CancellationReasonsService.getCancellationReasons(payload),
    enabled: options.enabled ?? true,
    retry: false,
  });

  return {
    ...data,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
    isError,
    error,
    refetch,
  };
};
